<!-- eslint-disable max-len -->
<template>
  <div class="absolute top-0 z-50 w-full p-3">
    <div class="w-12 h-12 rounded-full ml-auto ring-blue-500 ring-2">
      <button
        type="button"
        class="rounded-full cursor-pointer bg-white"
        id="options-menu"
        aria-expanded="true"
        aria-haspopup="true"
        v-on:click="isToggled = isToggled ? false : true"
      >
        <img
          v-bind:src="$store.state.account.user.photoURL"
          alt="pfp"
          class="w-12 h-12 rounded-full"
        />
      </button>
    </div>
    <div
      v-if="isToggled"
      tabindex="0"
      @keydown.esc="isToggled = false"
      @click="isToggled = false"
      class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none mr-3"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu"
    >
      <div class="py-1" role="none">
        <router-link
          :to="{ name: 'Account' }"
          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left"
          role="menuitem"
          >Account</router-link
        >
        <router-link
          :to="{ name: 'Dashboard' }"
          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left"
          role="menuitem"
          >Dashboard</router-link
        >
      </div>
      <div class="py-1" role="none">
        <router-link
          :to="{ name: 'Help' }"
          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left"
          role="menuitem"
          >Help</router-link
        >
      </div>
      <div class="py-1" role="none">
        <button
          @click="singOut()"
          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left"
          role="menuitem"
        >
          Sign out
        </button>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import { firebase } from '../firebase';

export default {
  name: 'TopNavbar',
  data() {
    return {
      isToggled: false,
    };
  },
  methods: {
    singOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          window.sessionStorage.clear();
          this.$router.replace({ name: 'Auth' });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
